export enum BookerDetailsFormDataHooks {
  ROOT = 'booker-details-form',
  TITLE = 'booker-details-form-title',
}
